import React, { useEffect, useRef, useState } from "react";
import CustomDropdownList from "../../Components/CustomDropdownList";
import "./Style/SearchBar.scss";

// SearchBar component that includes a dropdown and a search input
const SearchBar = (props) => {
  const {
    searchInput, // current value of the search input
    setSearchInput, // function to update the search input
    options, // dropdown options
    selected, // currently selected dropdown option
    onCompanyResearchOptionsChange, // handler for dropdown change
    showSearchSuggestions = false,
    searchSuggestion = [],
    onSearchFocus,
    onHistoryClick,
    onSuggestionClick,
    setShowSearchSuggestion, // pass this from parent
  } = props;

  const searchInputRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (
        searchInputRef.current &&
        searchInputRef.current.contains(event.target)
      ) {
        setShowSearchSuggestion(true);
      } else {
        setShowSearchSuggestion(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [setShowSearchSuggestion]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const trimmedInput = searchInput.trim();
      if (trimmedInput.length >= 3) {
        onSuggestionClick(trimmedInput);
      } else {
        onHistoryClick(trimmedInput);
      }
      setShowSearchSuggestion(false);
    }
  };

  // Handles changes in the search input field
  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  return (
    <>
      <div className="search-bar d-flex flex-row align-items-center">
        {/* Dropdown section */}
        <div className="dropdown-container">
          <CustomDropdownList
            data={options} // dropdown options data
            className="report-type-dropdown custom-combobox-list no-border-radius-right" // custom styling
            value={selected?.id} // currently selected value
            handleChange={onCompanyResearchOptionsChange} // dropdown change handler
          />
        </div>

        {/* Search input field section */}
        <div className="searchinput-container" style={{ borderLeft: "none" }}>
          <input
            ref={searchInputRef}
            type="text"
            name="search"
            placeholder="Search Here.." // placeholder text
            className="search-input" // custom input styling
            value={searchInput} // controlled input value
            onChange={handleSearchChange} // change handler
            autoComplete={"off"}
            onFocus={onSearchFocus}
            onKeyDown={handleKeyDown}
          />
          {/* Search icon displayed inside input container */}
          <span
            className="material-icons-outlined icon-fs-20 search-icon"
            style={{ color: "#3F7FE0" }}
          >
            search
          </span>

          {showSearchSuggestions && (
            <div className="input_div search_results_box">
              <ul>
                {searchSuggestion.length === 0 ? (
                  <li className="no-suggestion">
                    <span className="d-flex justify-content-center align-items-center">
                      {searchInput.length >= 3
                        ? "No suggestions found"
                        : "No recent history"}
                    </span>
                  </li>
                ) : (
                  searchSuggestion.map((ele, index) => (
                    <li
                      key={index}
                      style={{
                        backgroundColor: "#FFFFFF",
                      }}
                      onClick={() => {
                        const tempElement = document.createElement("div");
                        tempElement.innerHTML = ele;
                        const content =
                          tempElement.textContent ||
                          tempElement.innerText ||
                          "";
                        setSearchInput(content);

                        searchInput.length >= 3
                          ? onSuggestionClick(content)
                          : onHistoryClick(content);
                      }}
                    >
                      <span dangerouslySetInnerHTML={{ __html: ele }} />
                      <span className="material-icons-outlined search_icon">
                        {searchInput.length >= 3 ? "search" : "history"}
                      </span>
                    </li>
                  ))
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SearchBar;
